<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">

            <!-- 查询 -->
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div id="emSppWarehousingDetSwdResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions :edit-disable="showEditBtns"
                                      ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">

                              <template #left-header>
<!--                                <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-down"-->

<!--                                           custom-label="入库确认"-->
<!--                                           v-bind:class="'btn btn-outline-primary btn-sm'">-->
<!--                                </em-button>-->
                              </template>



                              <template #customRowActions="{row}">
                                <b-button-group>

                                  <em-button type="gotoGrandParent"
                                             v-bind:class="'btn btn-outline-primary btn-sm'"
                                             @click="gotoGrandParentLevel(row)">
                                  </em-button>
                                </b-button-group>
                              </template>


                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author thq
    // Date 2021-06-02 17:41:26

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import emApiMixin from "@/mixin/em/common/api";

    export default {
        name: "emSppWarehousingDetSwdListView",
        data(){
          return{
            mainId: "",
            showEditBtns: false
          }
        },
        mixins: [emCommonListMixin,emCommonGotoMixin,emApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            },
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName;
            },
            entityBaseUrl() {
              return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
            },

        },
      created: function () {
          let _this = this
          console.log("传递的主表ID =>>>" + this.$route.query.mainId)
          //上级传递的主表ID
          this.mainId = this.$route.query.mainId
          //this.existStorage(this.mainId)
          let url = `${this.entityBaseUrl}existStorage`
          this.$_emApiMixin_post(url, {spwId: this.mainId})
              .then(response => {
                    console.log("------------------------>>>>>>>>")
                    console.log(response.data.bExistStorage)
                    console.log("------------------------<<<<<<<<")

                    _this.showEditBtns = response.data.bExistStorage

                    if(_this.showEditBtns == true){
                      commonViewsUtil.showSuccess(this, "当前入库单已确认入库，不可更改！")
                    }
                    _this.$refs.emListFilter.doQuery()
                  }
              )
      },
      methods: {
          gotoGrandParentLevel(row) {
            this.$_emGotoMixin_gotoList("emSppWarehousingSpw", row.swdIdSpw ? row.swdIdSpw : this.mainId)
          },
          // existStorage(mainId){
          //   let url = `${this.entityBaseUrl}existStorage`
          //   this.$_emApiMixin_post(url, {SpwId: mainId})
          //       .then(response => {
          //             console.log("返回的数据：" + response.body)
          //             commonViewsUtil.showSuccess(this, "入库成功")
          //             this.$refs.emListFilter.doQuery()
          //           }
          //       )
          // }
        }
    };
</script>
